class MemoryLocalStorage {
    constructor() {
        this._data = {};
    }
    setItem(id, val) {
        this._data[id] = val;
    }
    getItem(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    }
    removeItem(id) {
        delete this._data[id];
    }
    clear() {
        this._data = {};
    }
}
export default MemoryLocalStorage;
//# sourceMappingURL=MemoryLocalStorage.js.map